// Angular
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
// Store
import { Store } from '@ngxs/store';
import { ErrorTrackState } from '../error-track/error-track.state';
// Action
import { ClearErrorException, LogErrorException } from '../error-track/action/error-track.action';
// Model
import { ERROR_STATUS, ERROR_TYPE, maxUrlLength } from '../error-track/model/error-code.model';
import { ErrorData, ExceptionError } from '../error-track/model/error-track.model';
// Service
import { AppService } from './app.service';

@Injectable({
	providedIn: 'root',
})
export class ErrorFactoryService {

	constructor(
		public store: Store,
		public appService: AppService
		) {
	}

	/**
	 * Log the Error Code
	 * @param error
	 * @param errorCodeModel
	 */
	public throwErrorExceptionCode(error: ErrorData | HttpErrorResponse, errorCodeModel: any): void {

		let exceptionData: ErrorData | HttpErrorResponse = error;
		let errorType = error['errorType'] | ERROR_TYPE.LOG;

		if (exceptionData instanceof HttpErrorResponse) {
			const errorUrl: string = error.url.replace(/.*\/\/[^/]*/, '');
			const requestUrl: string = errorUrl.substring(0, maxUrlLength);
			exceptionData = {
				requestUrl,
				payload: error['payload']
			};

			errorType = ERROR_TYPE.REQUEST;
		}

		this.store.dispatch(new LogErrorException({
			errorId: errorCodeModel,
			errorType: errorType,
			data: exceptionData
		}));
	}

	/**
	 * Retrieve the list of error in a Human Readable way
	 */
	public retrieveLatestCodeErrors(errorType: ERROR_TYPE[], fullLog = false, disposeErrors = true): string {
		let errorResult = null;
		// Retrieve last error if exists
		const errorTrack: ExceptionError[] = this.store.selectSnapshot(ErrorTrackState.exceptionErrorList);
		if (errorTrack && errorTrack.length > 0) {
			const newErrors: ExceptionError[] = errorTrack.filter(
				(exceptionError: ExceptionError) =>
					exceptionError.status === ERROR_STATUS.NEW && errorType.includes(exceptionError.errorType)
			);
			if (newErrors) {
				if (!fullLog) {
					errorResult = newErrors.map((exceptionError: ExceptionError) => {
						return exceptionError.errorId;
					}).toString();
				} else {
					errorResult = JSON.stringify(newErrors);
				}
				if (disposeErrors) {
					// Dispose all errors so are not being caught in the next error prompt
					this.store.dispatch(new ClearErrorException(errorType));
				}
			}
		}

		return errorResult;
	}
}
